define('views/modules/conversation/message/reply-list',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // models
    'collections/member/supervisors',
    // views
    'views/parts/list/list',
    'views/modules/conversation/message/reply-list-item',
], function(
    // Libs
    _, Backbone, Mustache, U,
    //models
    Supervisors,
    // views
    VList,
    VReplyListItem
) {

    var VReplyList = VList.extend({
        item: VReplyListItem,

        initialize: function() {
            this.listenTo(Supervisors, 'sync', this.render);
        },

        getItemOptions: function(options) {
            return _.extend(options, {
                supervisors: Supervisors
            }, _.pick(this.options, ['conversation']));
        },
    });

    return VReplyList;

});

